import {Dropdown, Text, TextField, Toggle} from '@/components/atoms'
import {Constants} from '@/utils/constants/commonConstants'
import {ANY_ID} from '@/utils/constants/promotionConstants'
import {Fragment} from 'react'
import PromotionSelectionModal from '../PromotionSelectionModal'
import {RewardItem} from './Rewards/RewardItem'
import {useBuyMultipleProductsCondition} from './useBuyMultipleProductsCondition'

const rowClassName = 'flex flex-wrap items-center gap-4'

export const BuyMultipleProductsCondition = ({
  promotionCondition,
  index,
  selectedPromotionCondition = 'UN',
  ModalComponent = PromotionSelectionModal,
}) => {
  const {
    isLoadingConfig,
    isAmountTab,
    currencyCode,
    isIndividualRewardsFeatureEnabled,
    hasIndividualRewards,
    rows,
    modalProps,
    modalConditionValues,
    handleBuyCount,
    handleBuyAmount,
    handleSelectedBuyItem,
    handleToggleIndividualRewards,
    handleSubmitModal,
    handleCloseModal,
  } = useBuyMultipleProductsCondition({promotionCondition, selectedPromotionCondition})

  if (!promotionCondition) {
    return null
  }

  const renderBuyFields = row => (
    <>
      <Text>{row.label}</Text>
      {isAmountTab ? (
        <>
          <Text>{currencyCode}</Text>
          <TextField
            updateValue={value => handleBuyAmount(value, row.condIndex)}
            value={row.buyCount?.toString() || ''}
            error={row.isError ? 'Value Invalid' : ''}
            uiSchema={{helperText: '', placeholder: '0.0'}}
            style={{maxWidth: '85px'}}
            type="number"
          />
        </>
      ) : (
        <Dropdown
          isJsonWrap={false}
          childList={row.qtyOptions}
          placeholder={ANY_ID}
          updateValue={values => handleBuyCount(values, row.condIndex)}
          isClearable={false}
          value={row.quantityValue}
          autocomplete="off"
          style={{width: 84}}
          loading={isLoadingConfig}
          isError={row.isError}
          errorMessage="Value Invalid"
        />
      )}
      <Dropdown
        isJsonWrap={false}
        childList={row.typeOptions}
        placeholder={row.selectedValuesText || Constants.AddProducts}
        value={[...row.productsValue]}
        updateValue={values => handleSelectedBuyItem(values, row.condIndex)}
        selection="multiple"
        isClearable={true}
        autocomplete="off"
        loading={isLoadingConfig}
        disabled={index > 0}
        className={index > 0 ? 'disable-dropdown-idx' : ''}
      />
    </>
  )

  const renderReward = (rewardIndex = 0, showDeleteLayer = true) => (
    <>
      <Text>{'and get'}</Text>
      <RewardItem
        promotionCondition={promotionCondition}
        index={index}
        rewardIndex={rewardIndex}
        showDeleteLayer={showDeleteLayer}
        ModalComponent={ModalComponent}
      />
    </>
  )

  return (
    <div className="flex flex-col gap-4">
      {index === 0 && isIndividualRewardsFeatureEnabled && (
        <Toggle
          value={hasIndividualRewards}
          updateValue={handleToggleIndividualRewards}
          uiSchema={{label: 'Enable Individual Rewards'}}
        />
      )}
      {hasIndividualRewards ? (
        // One row per buy condition, each with its own reward; the layer's delete button sits on the last row
        rows.map(row => (
          <div key={row.condIndex} className={rowClassName}>
            {renderBuyFields(row)}
            {renderReward(row.condIndex, row.condIndex === rows.length - 1)}
          </div>
        ))
      ) : (
        <div className={rowClassName}>
          {rows.map(row => (
            <Fragment key={row.condIndex}>{renderBuyFields(row)}</Fragment>
          ))}
          {renderReward()}
        </div>
      )}
      <ModalComponent
        key={JSON.stringify(modalProps)}
        show={modalProps.show}
        type={modalProps.type}
        onClose={handleCloseModal}
        onSubmit={handleSubmitModal}
        conditionValues={modalConditionValues}
      />
    </div>
  )
}
